import { IconButton } from '@astryxdesign/core/IconButton';
import { SegmentedControl, SegmentedControlItem } from '@astryxdesign/core/SegmentedControl';
import { MoonIcon, SunIcon } from '@phosphor-icons/react';
import { setThemeMode, useThemeMode, type ThemeMode } from './mode';

/** Full choice: dark, light, or follow the device. */
export function ThemeModeControl() {
  const { mode } = useThemeMode();
  return (
    <SegmentedControl label="Оформление" value={mode} onChange={(v) => setThemeMode(v as ThemeMode)} layout="fill">
      <SegmentedControlItem value="dark" label="Тёмная" />
      <SegmentedControlItem value="light" label="Светлая" />
      <SegmentedControlItem value="system" label="Как в системе" />
    </SegmentedControl>
  );
}

/** One-tap switch between dark and light. */
export function ThemeToggleButton({ className }: { className?: string }) {
  const { scheme } = useThemeMode();
  const next = scheme === 'dark' ? 'light' : 'dark';
  return (
    <IconButton
      label={next === 'light' ? 'Включить светлую тему' : 'Включить тёмную тему'}
      variant="secondary"
      className={className}
      icon={next === 'light' ? <SunIcon size={20} /> : <MoonIcon size={20} />}
      onClick={() => setThemeMode(next)}
    />
  );
}
